export const ArrowBack = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 20.47C0.5 9.70042 9.23045 0.969971 20 0.969971C30.7696 0.969971 39.5 9.70042 39.5 20.47C39.5 31.2395 30.7696 39.97 20 39.97C9.23045 39.97 0.5 31.2395 0.5 20.47Z"
      fill="white"
    />
    <path
      d="M0.5 20.47C0.5 9.70042 9.23045 0.969971 20 0.969971C30.7696 0.969971 39.5 9.70042 39.5 20.47C39.5 31.2395 30.7696 39.97 20 39.97C9.23045 39.97 0.5 31.2395 0.5 20.47Z"
      stroke="#E5E7EB" fill="none"
    />
    <path
      d="M17.5704 27.2901C17.3804 27.2901 17.1904 27.2201 17.0404 27.0701L10.9704 21.0001C10.6804 20.7101 10.6804 20.2301 10.9704 19.9401L17.0404 13.8701C17.3304 13.5801 17.8104 13.5801 18.1004 13.8701C18.3904 14.1601 18.3904 14.6401 18.1004 14.9301L12.5604 20.4701L18.1004 26.0101C18.3904 26.3001 18.3904 26.7801 18.1004 27.0701C17.9604 27.2201 17.7604 27.2901 17.5704 27.2901Z"
      fill="#6B7280"
    />
    <path
      d="M28.4999 21.22H11.6699C11.2599 21.22 10.9199 20.88 10.9199 20.47C10.9199 20.06 11.2599 19.72 11.6699 19.72H28.4999C28.9099 19.72 29.2499 20.06 29.2499 20.47C29.2499 20.88 28.9099 21.22 28.4999 21.22Z"
      fill="#6B7280"
    />
  </svg>
);
